"use client";

import { Link } from "react-router-dom";
import useFetchCategories from "../../lib/hooks/use-fetch-categories";

export default function CategoryList() {
    
  const {categories} = useFetchCategories();
  return (
    <>
      <div className="dashboard-page-title">
        <div className="breadcrumbs">
          <Link to="/admin">Admin Dashboard</Link>
          <Link to="/admin/products">Products</Link>
          <span>Categories</span>
        </div>
      </div>

      <div className="dashboard-page-content">
        <div className="flex flex-row align-items-center mb10">
          <span className="group-btn"></span>
          <span className="spacer align-items-center justify-content-center">
            -
          </span>
          <span className="group-btn">
            <Link to="/admin/products/newcategory">
              New Cat<span className="sm-hide">egory</span>
            </Link>
          </span>
        </div>

        <div className="dashboard-navgation">
          <ul>
            {categories.map((item: any) => (
              <li key={item.id}>
                <Link to={`#`} style={{ minHeight: "100px" }}>
                  {item.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}
